import { LoadPanel, Popup, Toast } from "devextreme-react";
import logomain from "../../../../images/logo-main.png";
import { ViewProductFunction } from "../ViewProductFunction";
import { useSelector } from "react-redux";
import { useState } from "react";
import { Auth } from "./Auth";
import { ReGenerate } from "./ReGenerate";

const ReGeneratePopup = ({
  ReGeneratePopupShow,
  setReGeneratePopupShow,
  setauthData,
  SetcopY,
}) => {
  return (
    <>
      <Popup
        visible={ReGeneratePopupShow}
        onHiding={() => {
          setReGeneratePopupShow(false);
        }}
        showTitle={false}
        width={465}
        height={320}
        showCloseButton={true}
        hideOnOutsideClick={true}
      >
        <ReGenerate
          setReGeneratePopupShow={setReGeneratePopupShow}
          ReGeneratePopupShow={ReGeneratePopupShow}
          setauthData={setauthData}
          SetcopY={SetcopY}
        />
      </Popup>
    </>
  );
};

export const ManageApp = ({
  subTab,
  success,
  setsuccess,
  setauthData,
  authData,
  setcopy,
  copy,
}) => {
  const clas = new ViewProductFunction();
  const { viewData } = useSelector((store) => store.dashboard);
  const [loading, setLoading] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const [ReGeneratePopupShow, setReGeneratePopupShow] = useState(false);

  return (
    <>
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        position={"top"}
        width={"auto"}
      />
      <ReGeneratePopup
        ReGeneratePopupShow={ReGeneratePopupShow}
        setReGeneratePopupShow={setReGeneratePopupShow}
        setauthData={setauthData}
        SetcopY={setcopy}
      />
      <div id="tab2" className={`tab-content ${subTab === 2 && `current`}`}>
        {!success ? (
          <div className="commonCard">
            <div className="proCard">
              <div className="proCard__flex">
                <div className="info">
                  <div className="pic">
                    <img className="pic__img" src={logomain} alt="UPA" />
                  </div>
                  <div className="text">Generate access keys</div>
                </div>
                <div className="btnActions">
                  <button
                    style={{ fontSize: "14px" }}
                    className="btn btn--primaryOutline"
                    onClick={() => {
                      clas.ManageApp(
                        setLoading,
                        {
                          isManageApp: true,
                        },
                        viewData,
                        setsuccess,
                        setauthData,
                        toastConfig,
                        setToastConfig,
                        setcopy
                      );
                    }}
                  >
                    Generate
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Auth
            authData={authData}
            subTab={subTab}
            setReGeneratePopupShow={setReGeneratePopupShow}
            CopY={copy}
            SetcopY={setcopy}
          />
        )}
      </div>
    </>
  );
};
